import { render, staticRenderFns } from "./ModelView.vue?vue&type=template&id=52319cba&scoped=true"
import script from "./ModelView.vue?vue&type=script&lang=js"
export * from "./ModelView.vue?vue&type=script&lang=js"
import style0 from "./ModelView.vue?vue&type=style&index=0&id=52319cba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52319cba",
  null
  
)

export default component.exports